import React from 'react';
import {actionArray as allActionsArray} from '../../../utils/allActionsArray.json';
import IamExAuditTableCell from './iamExAcAuditTableCell/iamExAcAuditTableCell.js';

const IamExAuditTableRow = ({user, headers}) => {

  const matchingActions = headers.map(header => {
    const regex = new RegExp(`^${header.replace('*', '.*')}$`);
    const matchedActions = allActionsArray.reduce((acc, action) => {
      if (regex.test(action)) acc.push({action, accounts: [{account: `${user.Account} (${user.AccountId})`, policies: []}]});
      return acc;
    }, []);
    return matchedActions;
  });

  return (
    <tr>
      <td>
        {user.UserName}
      </td>
      <td>
        {user.Account}
      </td>
      <td>
        {user.AccountId}
      </td>
      <td>
        {user.MFADevices.length > 0 ? 'True' : 'False'}
      </td>
      {matchingActions.map((actions, index) => {
        return <IamExAuditTableCell key={headers[index]} user={user} actions={actions}/>;
      })}
    </tr>
  );

};

export default IamExAuditTableRow;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExActions/iamExAcUserPermissions/iamExAcAuditTableRow/iamExAcAuditTableRow.js